<header class="grid-x header">
    <button [class._close]="!menuVisible" class="cell shrink header-buttonMenu"
            (click)="toggleMenuVisible()"></button>
    <!--[class.inner-table]="selectedAnimator"-->

    <div class="cell auto grid-x align-justify align-middle header-content">
        <div *ngIf="user" class="cell shrink userProfile">
            <img *ngIf="user.player" class="userProfile-img" src="assets/images/svg/header/players.svg">
            <img *ngIf="user.animator" class="userProfile-img" src="assets/images/svg/header/animators.svg">
            <div class="userProfile-name">
                {{user.person.firstName}} <br>
                <span>{{user.person.lastName}}</span>
            </div>
        </div>

        <div *ngIf="user" class="cell shrink userInfos">
            <div class="userInfos-item" *ngIf="sessionName">
                <i class="fas fa-gamepad"></i> {{sessionName}}
            </div>
            <div class="userInfos-item" *ngIf="user.player && teamName">
                <i class="fas fa-user-friends"></i> {{teamName}}
            </div>
        </div>

        <div class="cell auto grid-x align-center align-middle restaurantInfos">
            <div *ngIf="displayRestaurantAreaInformation" class="cell shrink restaurantInfos-item">
                <img class="restaurantInfos-item-img" src="assets/images/png/header/area.png">
                <span class="restaurantInfos-item-text show-for-xlarge">{{('common.area.' + area) | translate}}</span>
                <span class="restaurantInfos-item-tooltip">
                    <span [i18nKey]="'header.restaurant.area'"></span>
                    <b class="hide-for-xlarge"><br>{{('common.area.' + area) | translate}}</b>
                </span>
            </div>

            <ng-container *ngIf="displayRestaurantStandingInformation">
                <div class="cell shrink restaurantInfos-item">
                    <img class="restaurantInfos-item-img" src="assets/images/png/header/standing.png">
                    <span class="restaurantInfos-item-text show-for-xlarge">{{standing}}</span>
                    <span class="restaurantInfos-item-tooltip">
                        <span [i18nKey]="'header.restaurant.standing'"></span>
                        <b class="hide-for-xlarge"><br>{{standing}}</b>
                    </span>
                </div>
                <div class="cell shrink restaurantInfos-item" *ngIf="starsNumber">
                    <img class="restaurantInfos-item-img" src="assets/images/png/header/starsNumber.png">
                    <span class="restaurantInfos-item-text show-for-xlarge">
                        {{('common.restaurant.type.' + restaurantType) | translate}}
                        <div>
                            <i *ngFor="let item of [].constructor(starsNumber)" class="fas fa-star"></i>
                        </div>
                    </span>
                    <span class="restaurantInfos-item-tooltip">
                        <span [i18nKey]="'header.restaurant.type'"></span>
                        <b class="hide-for-xlarge"><br>{{('common.restaurant.type.' + restaurantType) | translate}}</b>
                    </span>
                </div>
            </ng-container>
        </div>

        <kiwi-period-time class="cell shrink"></kiwi-period-time>

        <div class="cell shrink grid-x align-middle" *ngIf="currentLanguage">
            <div class="languageSelectorContainer" *ngIf="false">
                <ul class="cell shrink languageSelector" [class._opened]="langPickerVisible"
                    (click)="toggleLangPicker()">
                    <li class="languageSelector-item">{{'common.language.long.' + currentLanguage | translate}}
                        <i class="fas fa-angle-down"></i></li>
                    <li class="languageSelector-item _list"
                        *ngFor="let language of languages"
                        [ngClass]="{'selected': isLangSelected(language)}"
                        (click)="changeLang(language)">
                        {{'common.language.long.' + language | translate}}
                    </li>
                </ul>
            </div>

            <button (click)="logout()" class="cell shrink logoutButton"><span [i18nKey]="'logout'"></span>
                <span class="kiwi-icon kiwi-logout _right"></span>
            </button>
        </div>
    </div>
</header>
